import { CDPType } from "../mutations/__generated__/useFeedPostCreateMutation.graphql";
import { assertNever } from "./typeUtils";

export const getCDPTypeNameMapping = (type: CDPType): string => {
  switch (type) {
    case "SHOPIFY":
      return "Shopify";
    case "KLAVIYO":
      return "Klaviyo";
    case "KINN":
      return "Kinn";
    case "OMETRIA":
      return "Ometria";
    case "EMARSYS":
      return "Emarsys";
    case "%future added value":
      return "";
    default:
      assertNever(type);
  }
};
